import type { SearchAttributes, SearchFacet } from "@/lib/types/search"

const selectedValue = (value: string) => ({ value, label: value, count: 0 })

export const facetsWithSelections = (facets: SearchFacet[] | undefined, attributes: SearchAttributes): SearchFacet[] => {
  const resolved = (facets ?? []).map((facet) => {
    const missing = (attributes[facet.key] ?? []).filter((value) => !facet.values.some((option) => option.value === value))
    return missing.length === 0 ? facet : { ...facet, values: [...facet.values, ...missing.map(selectedValue)] }
  })
  const missingFacets = Object.keys(attributes).filter((key) => !resolved.some((facet) => facet.key === key))
  return [...resolved, ...missingFacets.map((key) => ({ key, label: key, values: (attributes[key] ?? []).map(selectedValue) }))]
}

export const toggledFacetValues = (values: string[], value: string): string[] => (values.includes(value) ? values.filter((entry) => entry !== value) : [...values, value])
